module.exports = __webpack_public_path__ + "img/engravingSymbol.d47f817.jpg";